import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { GdToastPage } from './gd-toast';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [
    GdToastPage,
  ],
  imports: [
    IonicPageModule.forChild(GdToastPage),
    FlexLayoutModule
  ],
  exports:[
    GdToastPage
  ]
})
export class GdToastPageModule {}



// WEBPACK FOOTER //
// ./src/components/gd-toast/gd-toast.module.ts